import { storageModel } from "../libs/storage-manager";
export const themes = {
  Light: {
    "--bg-Color-group-1": "#FFFFFF",
    "--bg-Color-group-2": "#F5F5F5",
    "--text-text-h1": "#1D1D1D",
    "--text-text-h2": "rgba(29, 29, 29, 0.6)",
    "--primary-Color": "#2E4CE4",
    "--button-primary-bg-default": "#2E4CE4",
    "--text-text-reverse1": "#FFFFFF",
    "--divider-color-2": "rgba(29, 29, 29, 0.05)",
  },
  Dark: {
    "--bg-Color-group-1": "#0A0A0A",
    "--bg-Color-group-2": "#0A0A0A",
    "--text-text-h1": "#FFFFFF",
    "--text-text-h2": "rgba(255, 255, 255, 0.6)",
    "--primary-Color": "#3B66F4",
    "--button-primary-bg-default": "#2E4CE4",
    "--text-text-reverse1": "#FFFFFF",
    "--divider-color-2": "rgba(255, 255, 255, 0.05)",
  },
};
const isDarkMode = storageModel.isDarkMode === "Y" ? true : false;
const activeTheme = isDarkMode ? themes.Dark : themes.Light;
Object.keys(activeTheme).forEach((property: string) => {
  document.documentElement.style.setProperty(
    property,
    activeTheme[property as keyof typeof activeTheme],
  );
});
